import { EmptyState } from '@eventbrite/eds-empty-state';
import { GhostGraphic } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import './CategoryBrowseEmptyState.scss';

export const CategoryBrowseEmptyState: React.FunctionComponent = () => {
    return (
        <section className="category-browse__empty-state">
            <EmptyState
                graphicType={<GhostGraphic />}
                title={gettext("We couldn't find anything")}
                description={gettext('Adjust your filters and try again')}
            />
        </section>
    );
};
